import messageCategory from "../constants/message-category";

const attachmentDisabled: string[] = [
  messageCategory.BoatDamageClaim,
  messageCategory.CarDamageClaim,
  messageCategory.ConstructionDamageClaim,
  messageCategory.ConstructionLeakageAndFire,
  messageCategory.ForestDamageClaim,
  messageCategory.LegalClaim,
  messageCategory.LiabilityClaim,
  messageCategory.PersonalInjuryClaim,
  messageCategory.PersonalInjuryInTrafficClaim,
  messageCategory.PetClaim,
  messageCategory.PropertyDamageClaim,
  messageCategory.PropertyLuggageClaim,
  messageCategory.TravelInjuryClaim,
  messageCategory.TravelInterruptionClaim,
];

const hideAttachments = (category: string): boolean =>
  attachmentDisabled.includes(category);

export default hideAttachments;
